var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseRoundFilled = function SvgCloseRoundFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "close_round-filled_svg__a",
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    fillRule: "evenodd",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75ZM9.277 7.898a.975.975 0 0 0-1.379 1.379L10.621 12l-2.723 2.723a.975.975 0 1 0 1.379 1.379L12 13.379l2.723 2.723a.975.975 0 1 0 1.379-1.379L13.379 12l2.723-2.723a.975.975 0 1 0-1.379-1.379L12 10.621 9.277 7.898Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#close_round-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B30",
    d: "M0 0h24v24H0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseRoundFilled);
export default ForwardRef;